import { FaSync, FaTrash } from "react-icons/fa";
import { SearchbarCom, SidenavbarCom } from "../../components";
import Icons from "../../assets/icon";
import Functions from "./index.function";
import localimgpath from "../../js/localimgpath";
const SingleChatMessage = () => {
  const {
    id,
    userChatData,
    userId,
    isLoading,
    queryClient,
    handleDeleteChat,
    handleDeleteMessage,
    setSelectedMessage,
    newMessage,
    sendMessageMutation,
    setNewMessage,
    groupedMessages,
    formatDateHeading,
    messagesEndRef,
    selectedMessage,
  } = Functions();
  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      <SearchbarCom />
      <div className="xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3 w-full flex">
        <div className="sm:w-1/5 xs:z-50">
          <SidenavbarCom />
        </div>
        <div className="xs:w-full sm:w-4/5 flex relative bg-[#121212] h-[calc(100vh-4rem)] xs:mx-2 sm:ml-3 lg:ml-4 overflow-hidden rounded-lg">
          {id === null ? (
            "Please Select chat"
          ) : (
            <div className="flex flex-col relative w-full mt-2 xs:px-2 sm:px-3 lg:px-5 ">
              <div className="flex justify-between border-b-[2px] border-[#646464] items-center w-full xs:py-3 sm:py-5 z-30">
                <div className="gap-3 flex justify-start items-center">
                  <div className="xs:w-8 xs:h-8 sm:w-10 overflow-hidden sm:h-10 bg-gray-600 rounded-full bg-goldMetallic">
                    <img
                      src={
                        userChatData?.first_user_id !== Number(userId)
                          ? userChatData?.first_user?.hero_image
                            ? `${localimgpath?.talentThumbnail}/${userChatData?.first_user?.hero_image}`
                            : Icons.adimIcon
                          : userChatData?.second_user?.logo
                          ? `${localimgpath?.companyLogo}/${userChatData?.second_user?.logo}`
                          : Icons.adimIcon
                      }
                      className="w-full h-full object-contain"
                      alt={
                        userChatData?.first_user_id !== Number(userId)
                          ? userChatData?.first_user?.real_name
                          : userChatData?.second_user?.name
                      }
                    />
                  </div>
                  <h3 className="xs:text-sm text-secondary sm:text-base lg:text-lg font-onestMedium">
                    {userChatData?.first_user_id !== Number(userId)
                      ? userChatData?.first_user?.real_name
                      : userChatData?.second_user?.name}
                  </h3>
                </div>
                <div className="flex gap-2 items-center">
                  <button
                    className={`bg-gray-700 text-white xs:text-xs xs:py-1.5 xs:px-2 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 rounded flex items-center gap-2 ${
                      isLoading
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    }`}
                    onClick={() =>
                      queryClient.invalidateQueries(["getMessages", id])
                    }
                    disabled={isLoading}
                  >
                    <FaSync className="text-white" /> Refresh
                  </button>
                  <button
                    className="bg-red-500 xs:text-xs xs:py-1.5 xs:px-2 sm:px-3 sm:py-1.5 lg:px-4 lg:py-2 rounded"
                    onClick={handleDeleteChat}
                  >
                    Delete Chat
                  </button>
                  {/* <img
                    src={Icons.informationIcon}
                    className="xs:w-4 xs:h-4 sm:w-4 sm:h-4 lg:w-5 lg:h-5 xl:w-6 xl:h-6 2xl:w-7 2xl:h-7"
                    alt=""
                  /> */}
                </div>
              </div>
              <div className="flex-1 overflow-y-auto dashboard-scrollbar xs:pr-1 sm:pr-2">
                {Object.entries(groupedMessages).map(([date, messages]) => (
                  <div key={date}>
                    <div className="text-center text-secondary xs:text-[10px] sm:text-xs mb-2 mt-4">
                      {formatDateHeading(date)}
                    </div>

                    {messages?.map((msg, index) => {
                      const isSender = msg?.sender_id === Number(userId);
                      const isLastMessage = index === messages.length - 1;
                      return (
                        <div
                          key={msg?.id}
                          onClick={() => setSelectedMessage(msg?.id)}
                          ref={isLastMessage ? messagesEndRef : null}
                        >
                          <div
                            className={`relative xs:text-xs sm:text-sm lg:text-base xs:p-2 sm:p-3 xs:mt-3 sm:mt-5 xs:rounded-lg sm:rounded-xl xs:w-60 sm:max-w-xs ${
                              isSender
                                ? "bg-goldMetallic text-secondary ml-auto"
                                : "bg-[#212121] text-secondary"
                            }`}
                          >
                            <p>{msg?.message}</p>
                            {selectedMessage === msg?.id && (
                              <button
                                className="absolute top-0 right-0 p-1"
                                onClick={() => handleDeleteMessage(msg?.id)}
                              >
                                <FaTrash className="text-red-500" />
                              </button>
                            )}
                          </div>
                          <span
                            className={`block xs:!text-[8px] sm:text-[10px] font-onestRegular text-[#646464] xs:mt-1 sm:mt-2 ${
                              isSender ? "text-right ml-auto" : "text-left"
                            }`}
                          >
                            {new Date(msg?.created_at).toLocaleString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                              month: "short",
                              day: "numeric",
                            })}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                ))}
              </div>
              <div className="xs:py-3 sm:py-5 w-full">
                <div className="relative">
                  <input
                    className="flex-1 pl-2 pr-8 sm:pr-10 py-3 w-full bg-[#212121] xs:text-[10px] sm:text-xs lg:text-sm text-[#646464] font-onestRegular rounded-md focus:outline-none"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Type a message..."
                  />
                  <div
                    className={`absolute top-1/2 transform -translate-y-1/2 right-3 rounded-full transition ${
                      newMessage.trim()
                        ? "cursor-pointer"
                        : " cursor-not-allowed"
                    }`}
                    onClick={() => {
                      if (newMessage.trim() !== "") {
                        sendMessageMutation.mutate(newMessage);
                      }
                    }}
                    disabled={!newMessage.trim()}
                  >
                    <img
                      src={Icons?.messageSendIcon}
                      className="xs:w-3 xs:h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                      alt="message Send Icon"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleChatMessage;
